import {companyOverview, CompanyOverview} from "./overview/CompanyOverviewTabComponent";
import {companyPriceHistory, CompanyPriceHistory} from "./price-history/CompanyPriceHistoryTabComponent";
import {companyNewsTab, CompanyNewsTab} from "./news/CompanyNewsTabComponent";

import Dividends from "./dividends";
import {companyShareholders, CompanyShareholders} from "./directors/CompanyShareholdersTabComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.tabs`;
    return angular.module(moduleName, [Dividends(moduleName)])
                  .component(CompanyShareholders, companyShareholders())
                  .component(CompanyNewsTab, companyNewsTab())
                  .component(CompanyOverview, companyOverview())
                  .component(CompanyPriceHistory, companyPriceHistory())
                  .name;
}
